export default "__VITE_ASSET__Dgzjaobc__"